export class LocationFilter {
  city: string;
  country: string;
  countryId: string;
  workType: number|null;
}
